<template>
  <div class="container">
    <iframe
      class="video"
      :src="src"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <h4>{{ this.video.snippet.title }}</h4>
  </div>
</template>

<script>
export default {
  name: "Video",
  data() {
    return {
      src: ""
    };
  },
  props: ["video"],
  created() {
    this.src = "https://www.youtube.com/embed/" + this.video.id.videoId;
  }
};
</script>

<style>
.video {
  width: 700px;
  height: 400px;
}

@media (max-width: 800px) {
  .video {
    width: 350px;
    height: 200px;
  }
}

@media (min-width: 800px) and (max-width: 1440px) {
  .video {
    width: 525px;
    height: 300px;
  }
}
</style>
